import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil, filter} from 'rxjs/operators';
import {SharedService} from '../../services/shared.service';
import {CustomerService} from '../../services/customer.service';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  whiteBar: boolean;
  isLoggedIn: boolean;
  promoPage: boolean;

  constructor(private router: Router,
              private shared: SharedService,
              private activated: ActivatedRoute,
              private customerService: CustomerService,
              private zone: NgZone) {
    this.customerService.authChanged()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(customer => {
        // if (!customer) return this.zone.run(() => this.router.navigate(['/']));
        this.isLoggedIn = !!customer;
      });
    this.router.events
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        let currentRoute = this.activated.root;
        let routeID;
        while (currentRoute.children[0] !== undefined) {
          currentRoute = currentRoute.children[0];
          routeID = currentRoute.snapshot.data['id'] || routeID;
        }
        this.whiteBar = routeID == 'account';
        this.promoPage = routeID == 'promo';
      });
  }

  ngOnInit() {
  }

  sideNav() {
    if (this.isLoggedIn) this.shared.sendEvent({type: 'side_nav'});
  }

  ngOnDestroy(): void {
    //Unsubscribe from all events
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


}
